import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// Ukuran kertas A4
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 10,
    width: "210mm",
    height: "297mm",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  kartu: {
    width: "100mm", // 2 kartu per baris
    height: "55mm", // 5 baris per halaman
    border: "1px solid black",
    borderRadius: 5,
    padding: 8,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 4,
  },
  text: {
    fontSize: 10,
  },
  list: {
    marginLeft: 10,
  },
});

// Fungsi membagi data agar pas di setiap halaman
const chunkArray = (array, chunkSize) => {
  let results = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    results.push(array.slice(i, i + chunkSize));
  }
  return results;
};

// Komponen PDF
const KartuUjianPDF = ({ data }) => {
  const perPage = 10; // 10 kartu per halaman (5 baris x 2 kolom)
  const pages = chunkArray(data, perPage);

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.page} wrap={false}>
          {chunkArray(pageData, 2).map((row, rowIndex) => (
            <View key={rowIndex} style={styles.row}>
              {row.map((item, index) => (
                <View key={index} style={styles.kartu} break={index % 10 === 0}>
                  <Text style={styles.title}>Kartu Ujian</Text>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>Kode Ujian : </Text>{item.kode}
                  </Text>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>Ruangan :</Text> {item.ruang}
                  </Text>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>Pengawas :</Text> {item.nama_guru}
                  </Text>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>Mata Pelajaran :</Text>
                  </Text>
                  <View style={styles.list}>
                    {item.data.map((m, i) => (
                      <Text key={i} style={styles.text}>{i+1} {m.nama_mapel} {m.nama_guru} ({m.id})  </Text>
                    ))}
                  </View>
                </View>
              ))}
            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default KartuUjianPDF;
